var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',[_c('h1',[_vm._v("QA Dashboard")]),_c('br'),_c('AllEventsTable'),_c('br'),_c('FactsByEventsTable'),_c('br'),_c('FactsByConflictTable'),_c('br'),_c('FactsByDisasterTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }